<template lang="pug">
  v-layout(wrap)
    v-flex(xs12 sm12 md5)
      s-datetime-picker(
        v-model='model.published_at'
        name='published_at'
        label='Дата публикации'
      )
    //- v-flex(xs12 sm6 md3)
    //-   s-date-picker(
    //-     v-model='model.on_date'
    //-     name='on_date'
    //-     label='Дата актуальности'
    //-     clearable
    //-   )
    v-flex(xs12 sm6 md4)
      v-checkbox(
        v-model='model.published'
        :label='label || "Запись опубликована"'
        color='primary'
      )
</template>

<script>
export default {
  props: ['model', 'label']
}
</script>
